import React from "react";

export default function Tabs({ tabs, activeIndex, onChange }) {
  return (
    <div className="w-full border-gray-200">
      <nav className="-mb-px flex space-x-6">
        {tabs.map((tab, index) => (
          <button
            type="button"
            key={index}
            onClick={() => onChange(index)}
            className={`whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-all
              ${
                activeIndex === index
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }
            `}
          >
            {tab}
          </button>
        ))}
      </nav>
    </div>
  );
}
